export enum GameConstants {
  GET_GAMES_SUCCESS = "GET_GAMES_SUCCESS",
  REFRESH_GAME = "REFRESH_GAME",
  ERROR = "ERROR",
};

